import * as Yup from "yup";
import { CompanyStatus } from "../../../../util/master-data";

const customerDetailsSchema = Yup.object({
  company_name: Yup.string().required("Company is required").max(255, "Cannot exceed 255 chars"),
  company_phone: Yup.string(),
  company_login_name: Yup.string()
    .required("Login name is required")
    .min(3, "Minimum 3 chars required")
    .max(255, "Cannot exceed 255 chars")
    .matches(/^[a-zA-Z0-9-_]+$/, "Only alphanumeric with hyphen or underscore is allowed"),
  company_logo: Yup.mixed().required("Logo is required"),
  company_address: Yup.string()
    .required("Address is required")
    .min(3, "Minimum 3 chars required")
    .max(255, "Cannot exceed 255 chars"),
  company_country: Yup.string().required("Country is required").max(255, "Cannot exceed 255 chars"),
  company_currency: Yup.string().required("Currency is required").max(255, "Cannot exceed 255 chars"),
  company_timezone: Yup.string().required("Timezone is required").max(255, "Cannot exceed 255 chars"),
  region: Yup.string().required("Region is required").max(255, "Cannot exceed 255 chars"),
  company_email: Yup.string()
    .required("Company email is required")
    .email("Please enter a valid email")
    .max(255, "Cannot exceed 255 chars"),
  company_industry: Yup.string().nullable().max(255, "Cannot exceed 255 chars"),
  company_verticals: Yup.string().nullable().max(255, "Cannot exceed 255 chars"),
  company_status: Yup.string()
    .required("Company Status is required")
    .oneOf(CompanyStatus, "Invalid Company Status"),
    cloneAccount:Yup.string().nullable().max(255, "Cannot exceed 255 chars"),
    migrationType:Yup.string().nullable().max(255, "Cannot exceed 255 chars"),
});
const adminDetailsSchema = Yup.object({
  emp_code: Yup.string()
    .required("Employee code is required")
    .min(3, "Minimum 3 chars required")
    .max(10, "Cannot exceed 10 chars"),
  first_name: Yup.string()
    .required("First name is required")
    .min(3, "Minimum 3 chars required")
    .max(255, "Cannot exceed 255 chars"),
  last_name: Yup.string()
    .required("Last name is required")
    .min(3, "Minimum 3 chars required")
    .max(255, "Cannot exceed 255 chars"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email")
    .max(255, "Cannot exceed 255 chars"),
  password: Yup.string()
    .required("Password is required")
    .min(3, "Minimum 3 chars required")
    .max(200, "Cannot exceed 200 chars"),
  designation: Yup.string().required("Designation is required").max(50,'Cannot exceed 50 chars'),
  home_phone_number: Yup.string()
    .min(3, "Please enter a valid phone number"),
  work_phone_number: Yup.string()
    .required("Work phone number is required")
    .min(3, "Please enter a valid phone number"),
  profile_picture: Yup.mixed().nullable(),
  notifyCustomer: Yup.boolean(),
});

const validationSchema = {
  customerDetailsSchema,
  adminDetailsSchema,
};
export default validationSchema;
